import { post } from "..";

const path = "/api";
export const apiGetToken = async ({
  login,
  password,
}: {
  login: string;
  password: string;
}): Promise<{ token: string; error: string | null }> =>
  post(`${path}/getTokenByLoginAndPass`, { login, password }, {}, false);
